import logoArtemis from "../images/logo-artemis.png";
import logoAtlantiki from "../images/logo-atlantiki.png";

// Per-account logo overrides. Accounts with no override fall
// back to the default Artemis logo.
const ACCOUNT_LOGO_OVERRIDES = [
  {
    logo: logoAtlantiki,
    width: 120,
    height: 25,
    matches: (account) => {
      return account?.clientId === "atlantiki";
    },
  },
];

export const getAccountLogo = (account) => {
  const override = ACCOUNT_LOGO_OVERRIDES.find((entry) =>
    entry.matches(account),
  );

  return override ? override : { logo: logoArtemis, width: 100, height: 43 };
};
